import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource, MatTable } from "@angular/material/table";
import { Subscription } from "rxjs";
import { SkuColumn } from "../models/sku-column";
import { SkuHistory } from "../models/sku-history";
import { SkuManagementService } from "../sku-management.service";
import { LoggingService } from 'src/app/core/services/logging.service';

@Component({
    selector: "app-sku-upload-history",
    templateUrl: "./sku-upload-history.component.html",
    styleUrls: ["./sku-upload-history.component.scss"],
    standalone: false
})
export class SkuUploadHistoryComponent implements OnInit, OnDestroy {
  dynamicColumn: SkuColumn[];
  displayedColumns: string[];
  dataSource: MatTableDataSource<SkuHistory>;
  loading: boolean;

  private fileUploadedSub$: Subscription;

  constructor(private skuManagementService: SkuManagementService) {}

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatTable, { static: true }) table: MatTable<SkuHistory>;

  ngOnInit() {
    this.dynamicColumn = this.skuManagementService.getColumns();
    this.displayedColumns = this.dynamicColumn.map(c => c.property);
    this.displayedColumns.push("download");
    this.dataSource = new MatTableDataSource();

    this.sort.active = "uploadDate";
    this.sort.direction = "desc";
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "uploadDate":
          return new Date(item.uploadDate);
        default:
          return item[property];
      }
    };

    this.loading = true;
    this.skuManagementService.getHistory$().subscribe(
      data => {
        this.dataSource.data = data;
        this.loading = false;
      },
      err => {},
      () => {
        LoggingService.log("sku history complete");
      }
    );

    this.fileUploadedSub$ = this.skuManagementService.fileUploaded$.subscribe(
      item => {
        if (item) {
          this.dataSource.data.push(item);
          this.dataSource.data = this.dataSource.data;
        }
      },
      err => {},
      () => {
        LoggingService.log("sku single history complete");
      }
    );
  }

  ngOnDestroy() {
    if (this.fileUploadedSub$) this.fileUploadedSub$.unsubscribe();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
